var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171 408c-9 0-17-3-23-9-5-6-9-14-9-23V204L8 52c-2-3-4-6-6-10-1-4-2-8-2-12 0-9 4-17 9-23 6-5 14-9 23-9h342c9 0 17 4 23 9 6 6 9 14 9 23 0 4 0 8-2 12-1 3-3 7-6 10L267 204v130c0 5-1 10-3 15-3 5-7 9-11 12l-64 42c-2 2-5 3-8 4s-7 1-10 1zM41 64h325l19-23c2-2 3-3 3-5 1-2 1-4 1-6 0-4-1-8-4-11-3-2-7-4-11-4H32c-4 0-8 2-11 4-2 3-4 7-4 11 0 2 0 4 1 6s2 3 3 5l20 23zm310 17H55l97 112c1 2 2 3 3 5s1 4 1 6v172c0 4 2 8 5 11 2 3 6 4 10 4h5c1-1 3-1 4-2l64-43c2-1 3-3 5-5 1-2 1-5 1-7V204c0-2 1-4 2-6 0-2 1-3 3-5l96-112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel);
export default __webpack_public_path__ + "static/media/FilterFunnel.44e6614f3863d6eea38d0887572fd947.svg";
export { ForwardRef as ReactComponent };